import *  as yup from 'yup'
export interface StateLoginsModel {
    stateLoginsId: number,
    stateId?: number,
    statename?: string,
    standardAbbv?: string,
    postalAbbv?: string,
    partnersId?: number,
    licensee?: string,
    website?: string,
    username?: string,
    password1?: string,
    password2?: string,
    client?: string,
    notes?: string,
    accountID?: string
}

export const StateLoginsModel_VS = yup.object({
    client: yup.string().min(1,"please select Client").required("Please select a Client").typeError('Invalid Value'),
    statename: yup.string().min(1,"please select State").required("Please select a State").typeError('Invalid Value'),
    licensee: yup.string().required("please enter Licensee").trim().typeError('Invalid value'),
    username: yup.string().required("please enter Username").trim().typeError('Invalid value'),
    password1: yup.string().required("please enter Password1").trim().typeError('Invalid value'),
})
